interface DataObject {
  month: number;
  trimester: number;
  min: number;
  max: number;
  avg: number;
  median: number;
  deviation: number;
  upper: number;
  lower: number;
}

export function createDataArray(
  arg1: number,
  arg2: number,
  arg3: number
): DataObject[] {
  const dataArray: DataObject[] = [];

  const values = [arg1, arg2, arg3];
  const initialMin = arg1;
  const initialMax = arg3;
  const initialAvg =
    values.reduce((acc, curr) => acc + curr, 0) / values.length;
  const initialSortedValues = values.sort((a, b) => a - b);
  const initialMedian =
    initialSortedValues[Math.floor(initialSortedValues.length / 2)];

  const initialDeviation = 0;

  const initialLower = arg1;
  const initialUpper = arg3;

  let min = initialMin;
  let max = initialMax;
  let avg = initialAvg;
  let median = initialMedian;
  const deviation = initialDeviation;
  let lower = initialLower;
  let upper = initialUpper;
  let trimester = 1;

  for (let i = 0; i < 58; i++) {
    const month = i;
    if (i < 4) {
      trimester = 1;
    } else {
      if ((i - 4) % 3 == 0) {
        trimester++;
      }
    }

    const dataObj: DataObject = {
      month,
      trimester,
      min,
      max,
      avg,
      median,
      deviation,
      upper,
      lower,
    };

    dataArray.push(dataObj);

    min += 0.03926;
    max += 0.030677;
    avg += 0.03497;
    median = avg;
    lower = min;
    upper = max;
  }

  return dataArray;
}